import config from '../config/env';
import {
    GUEST_SESSION_HEADER,
    GUEST_SESSION_SECRET_HEADER,
} from './guestSessionStorage';

class PublicAPIClient {
    constructor() {
        this.baseURL = config.BACKEND_URL;
        this.timeout = config.API_TIMEOUT;
        this.defaultHeaders = {
            'Content-Type': 'application/json',
        };
        this.guestSessionId = null;
        this.guestSessionSecret = null;
    }

    setGuestSession(sessionId, joinCode) {
        this.guestSessionId = sessionId || null;
        this.guestSessionSecret = joinCode || null;
    }

    getGuestSession() {
        return this.guestSessionId;
    }

    getGuestSessionSecret() {
        return this.guestSessionSecret;
    }

    clearGuestSession() {
        this.guestSessionId = null;
        this.guestSessionSecret = null;
    }

    async makeRequest(url, options = {}) {
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), this.timeout);

        const headers = {
            ...this.defaultHeaders,
            ...options.headers,
        };

        if (this.guestSessionId) {
            headers[GUEST_SESSION_HEADER] = this.guestSessionId;
        }

        if (this.guestSessionSecret) {
            headers[GUEST_SESSION_SECRET_HEADER] = this.guestSessionSecret;
        }

        try {
            const response = await fetch(url, {
                ...options,
                headers,
                signal: controller.signal,
            });

            clearTimeout(timeoutId);

            if (!response.ok) {
                const contentType = response.headers.get('content-type');
                let errorData = {};
                if (contentType && contentType.includes('application/json')) {
                    errorData = await response.json().catch(() => ({}));
                }
                const error = new Error(
                    errorData.message || `HTTP ${response.status}: ${response.statusText}`
                );
                error.status = response.status;
                error.data = errorData.data || null;
                error.reason = errorData.data?.reason || null;
                throw error;
            }

            return response;
        } catch (error) {
            clearTimeout(timeoutId);
            throw error;
        }
    }

    async get(endpoint, options = {}) {
        const url = `${this.baseURL}${endpoint}`;
        const response = await this.makeRequest(url, {
            method: 'GET',
            ...options,
        });

        return response.json();
    }

    async post(endpoint, data, options = {}) {
        const url = `${this.baseURL}${endpoint}`;
        const response = await this.makeRequest(url, {
            method: 'POST',
            body: JSON.stringify(data),
            ...options,
        });

        return response.json();
    }
}

const publicApiClient = new PublicAPIClient();
export default publicApiClient;
